// extracted by mini-css-extract-plugin
module.exports = {"btnWithAddon":"index_btnWithAddon_grcaS","btnAddon":"index_btnAddon_2pjXJ","btnAddonIcon":"index_btnAddonIcon_3WIxK"};